
import { Image, get_prop } from 'utils'
import { RISK_CHOICE, is_risk_result_type, TYPE } from 'network/server_tool'
import { Button } from 'button'
import { mini_balls_desk } from './balls'

import {getMinorUnitText} from'./abstract';
import {formatTimeString} from './table';

export default function( space, container, settings )
{
    const config = settings.risk

    const containerMultRisk = new PIXI.Container();
    container.addChild(containerMultRisk);
    const containerTableRisk = new PIXI.Container();
    container.addChild(containerTableRisk);

    space.s( 'sportbet:table_mode' ).on(isTable => {
        containerMultRisk.visible = !isTable;
        containerTableRisk.visible = isTable;
    })

    if ( config.background ) {
        const background = Image( config.background )
        if ( config.background_position ) background.position.set( config.background_position.x, config.background_position.y )
        containerMultRisk.addChild( background )
    }

    function label( desc, parent ) {

        if (!desc) return;

        const l = new PIXI.extras.BitmapText(
            '',
            {
                font : desc.font,
                align : desc.align,
            },
        )
        parent.addChild( l )
        l.position.set( desc.position.x, desc.position.y )

        switch ( desc.align ) {
            case 'left':
                l.anchor.set(0.0, 0.0);
                break;
            case 'right':
                l.anchor.set(1.0, 0.0);
                break;
            case 'center':
                l.anchor.set(0.5, 0.0);
                break;
            default:
                l.anchor.set(0.5, 0.0);
                break;
        }
        return l
    }

    const currentStepLabel = label(config.currentStepLabel, containerMultRisk);
    const stepsLabel = label(config.stepsLabel, containerMultRisk);
    stepsLabel.text = '5';

    const current_win_label = label( config.currentWinLabel, containerMultRisk )
    const next_win_label = label( config.nextWinLabel, containerMultRisk )

    let toggle_card = 0;
    const $needBlinkCard = space.s('risk:need_blink_card');
    const $currentBlinkCard = space.s('risk: current_blink_card', toggle_card);

    const red_shirt = Image( config.centralCard.redShirt )
    red_shirt.position.set( config.centralCard.position.x, config.centralCard.position.y )
    containerMultRisk.addChild( red_shirt )
    const black_shirt = Image( config.centralCard.blackShirt )
    black_shirt.position.set( config.centralCard.position.x, config.centralCard.position.y )
    containerMultRisk.addChild( black_shirt );

    $currentBlinkCard.on(card => {
        red_shirt.visible = !card;
        black_shirt.visible = !!card;
    });

    let shirt_blink = 0
    const PERIOD = 0.5

    $needBlinkCard.filter(need => need).on(() => shirt_blink = 0);

    space.s( 'ticker' )
        .with($needBlinkCard, (s, blink) => ({s, blink}))
        .filter(({blink}) => blink)
        .on(({s}) => {
            shirt_blink += s;
            if (shirt_blink > PERIOD) {
                if (card_blink_sound) {
                    card_blink_sound.stop();
                    card_blink_sound.play();
                }
                shirt_blink = 0;
                toggle_card = 1 - toggle_card;
                $currentBlinkCard.next( toggle_card );
            }
        });


    function button( desc ) {
        const b = new Button(
            PIXI.utils.TextureCache[ desc.state.normal ],
            PIXI.utils.TextureCache[ desc.state.over ],
            PIXI.utils.TextureCache[ desc.state.pressed ],
            PIXI.utils.TextureCache[ desc.state.disabled ],
        )
        b.position.set( desc.position.x, desc.position.y )
        containerMultRisk.addChild( b )
        b.enabled = false
        return b
    }
    const red_button = button( config.redButton )
    red_button.callback = () => space.s( 'risk:choiceOut' ).next( RISK_CHOICE.RED )
    const black_button = button( config.blackButton )
    black_button.callback = () => space.s( 'risk:choiceOut' ).next( RISK_CHOICE.BLACK )
    space.s( 'risk:choiceIn' ).on( choice => {
        const fakePointerData = {data:{originalEvent:{button:0}}}
        if ( choice == RISK_CHOICE.RED ) {
            red_button.emit('pointerdown', fakePointerData)
        }
        else if ( choice == RISK_CHOICE.BLACK ) {
            black_button.emit('pointerdown', fakePointerData)
        }
        red_button.enabled = false
        black_button.enabled = false
    } )

    const history_cards = []
    function show_history( history ) {
        //destroy previous:
        for ( const h of history_cards ) h.destroy( { children : true } )
        history_cards.length = 0

        const final_history = history.slice().reverse()

        let index = 0
        for ( const h of final_history ) {
            if ( index >= config.history.length ) break
            const i = Image( config.history.suits[ h.suit ] )
            i.position.set( config.history.position.x + index * config.history.cardOffset, config.history.position.y )
            i.scale.set( config.history.cardScale )
            containerMultRisk.addChild( i )
            history_cards.push( i )
            ++ index
        }
    }

    let win_sound = null;
    if (config.win_sound) {
        win_sound = sounds.get(config.win_sound)
    }
    let lose_sound = null;
    if (config.lose_sound) {
        lose_sound = sounds.get(config.lose_sound);
    }
    let card_blink_sound = null;
    if (config.blink_sound) {
        card_blink_sound = sounds.get(config.blink_sound);
    }

    //табличный режим риска
    const tableBackground = Image( config.table_background );
    if ( config.table_background_position ) tableBackground.position.set( config.table_background_position.x, config.table_background_position.y );
    containerTableRisk.addChild(tableBackground);

    const tableLightPlates = [];
    for (let i = 0; i < 2; ++i) {
        let plate = Image(config.light_plates.name);
        plate.x = config.light_plates.x;
        plate.y = config.light_plates.y[i];

        let ball = Image( (i === 0) ? 'res/games/risk/risk_table_ball_red.png' : 'res/games/risk/risk_table_ball_black.png');
        ball.anchor.set(0.5, 0.5);
        ball.position.set(plate.width / 2, plate.height / 2);
        plate.addChild(ball);

        tableBackground.addChild(plate);
        tableLightPlates.push(plate);
    }

    const tableCurrentStepLabel = label(config.tableCurrentStepLabel, containerTableRisk);
    const tableStepsLabel = label(config.tableStepsLabel, containerTableRisk);
    tableStepsLabel.text = '5';

    const check = Image( config.check );
    check.position.set(408, 60 + 126);
    check.visible = false;
    containerTableRisk.addChild(check);

    let ballSprite = new PIXI.Sprite();
    ballSprite.anchor.set(0.5, 0.5);
    ballSprite.position.set(186, 216);
    check.addChild(ballSprite);

    function textInCheck( pos, align ) {
        const t = new PIXI.Text(
            '',
            {
                fontSize : 12,
                fill : 0x000000,
                align : align || 'center',
                fontWeight : 'bold',
            },
        )
        if (!align || align === 'center') {
            t.anchor.set(0.5)
        }
        t.position.set( pos[ 0 ], pos[ 1 ] )
        check.addChild( t )
        return t
    };

    const number = textInCheck( [ 217, 13 ], 'left' );
    number.text = settings.cheque.pari;
    const step = textInCheck( [ 160, 67 ], 'left' );
    const event = textInCheck( [ 173, 80 ], 'left' );
    const playerChoise = textInCheck([184, 104], 'center');
    const time = textInCheck( [ 184, 140 ] );
    const stepComplete = textInCheck([184, 280]);
    stepComplete.text = 'Шаг выполнен';
    const step_time = textInCheck( [ 184, 298 ] );
    const step_win = textInCheck( [ 184, 320 ] );
    const comp_time = textInCheck( [ 184, 382 ] );

    const step_result = textInCheck( [184, 398]);
    const step_details = textInCheck( [184, 412]);

    const step_counted = textInCheck( [184, 457] );

    space.s( 'risk:result' ).on( ({ state, result }) => {
        const s = state.state
        step.text = get_prop( s, [ 'math_info', 'bet_id' ], '940.000004393796' )
        event.text = get_prop( s, [ 'math_info', 'source', 'id' ] )
        playerChoise.text = 'Выбран ' + ((result.playerChoise) ? 'черный' : 'красный') + ' шар';
        time.text = formatTimeString(get_prop( s, [ 'math_info', 'source', 'created' ], '' ).toString());
        step_time.text = formatTimeString(get_prop( s, [ 'math_info', 'created' ], '' ).toString());
        let step_size = (result.currentWin) ? result.currentWin / 2 : (s.previous_state && s.previous_state.open_win) ? s.previous_state.open_win : 0;
        step_win.text = 'Размер шага, баллов: %s.00'.$( step_size );
        comp_time.text = formatTimeString(get_prop( s, [ 'math_info', 'computed' ], '' ).toString());

        if (result.currentWin) {
            step_result.text = 'Результат шага, баллов: ' + getMinorUnitText(result.currentWin, space);
            step_details.text = '( ' + getMinorUnitText(result.currentWin / 2, space) + ' * ' + '2 )';
            step_counted.text  = 'Шаг засчитан';
        }
        else {
            step_result.text = 'Результат отсутствует';
            step_details.text = "";
            step_counted.text  = '';
        }

        let texture = (result.playerChoise) ?
            ((result.currentWin > 0) ? PIXI.utils.TextureCache['res/games/risk/risk_table_ball_black.png'] : PIXI.utils.TextureCache['res/games/risk/risk_table_ball_red.png'])
            :
            ((result.currentWin > 0) ? PIXI.utils.TextureCache['res/games/risk/risk_table_ball_red.png'] : PIXI.utils.TextureCache['res/games/risk/risk_table_ball_black.png'])
        ballSprite.texture = texture;

        check.visible = true;

    });

    space.s( 'risk:startRound' ).on(() => check.visible = false);

    space.s( 'risk:startRound' )
        .on( round => {
            tableCurrentStepLabel.text = round.step;
        });

    $currentBlinkCard.on(card => {
        tableLightPlates[card].visible = true;
        tableLightPlates[1-card].visible = false;
    });

    //табличный режим -  конец

    space.s( 'risk:startRound' ).to( space.s( 'risk:startComplete' ) )
    space.s( 'risk:startRound' ).map(() => true).to($needBlinkCard)
    space.s( 'risk:leave' ).map(() => false).to($needBlinkCard)
    space.s( 'risk:startRound' )
        .on( round => {

            currentStepLabel.text = round.step.toString();

            current_win_label.text = getMinorUnitText(round.currentWin.toString(), space)
            next_win_label.text = getMinorUnitText(round.futureWin.toString(), space)

            red_button.enabled = true
            black_button.enabled = true

            show_history( round.history )

            if ( card ) card.destroy( { children : true } )
            card = undefined
    } )

    let card

    space.s('risk:choiceIn').map(() => false).to($needBlinkCard);
    space.s('risk:choiceIn')
        .map(choice => {
            if (choice === RISK_CHOICE.RED) {
                return 0;
            }
            else {
                return 1;
            }
        })
        .to($currentBlinkCard);
    space.s( 'risk:result' ).map(() => false).to($needBlinkCard);
    space.s( 'risk:result' ).on( ({ state, result }) => {
        show_history( result.history )

        current_win_label.text = getMinorUnitText(result.currentWin.toString(), space);
        next_win_label.text = getMinorUnitText(result.futureWin.toString(), space);

        if ( card ) card.destroy( { children : true } )
        card = Image( config.suits[ result.cardSuit ] )
        card.position.set( config.centralCard.position.x, config.centralCard.position.y )
        containerMultRisk.addChild( card )

        if (result.currentWin) {
            if (win_sound) {
                win_sound.play()
            }
        }
        else {
            if (lose_sound) {
                lose_sound.play()
            }
        }

    } )

    //как альтернатива, можно поставить большую задержку у space.s( 'risk:result' ), что бы дождаться выката шара
    space.s( 'sportbet:risk_balls_desk:end_roll' )
        .delay(2000)
        .to(space.s( 'risk:showComplete' ));


    //balls:
    mini_balls_desk( space, space.child( 'sportbet:risk_balls_desk' ), container, settings )
    //how many balls already rolled (no matter already staying still or rolling in):
    let restored = false
    space.s( 'state' )
        .map( state => {
            if ( ! [ TYPE.RISK_MAIN, TYPE.RISK_RESULT_RED, TYPE.RISK_RESULT_BLACK ].includes( state.type ) ) return { reset : true, balls : [] }

            let balls = []

            //from history:
            if ( ! restored ) {
                for ( let i = (state.server.riskHistoryData.length - state.state.risk_iteration); i < state.server.riskHistoryData.length; ++ i ) {
                    balls.push({
                        s : [ 0, 1 ].includes( state.server.riskHistoryData[ i ].suit ) ? 'red' : 'black',
                        no_rotating : true,
                        ended : true,
                    })
                }
                restored = true
            }

            //current result:
            if ( is_risk_result_type( state.type ) ) {
                let win = state.state.open_win;
                let color = (state.type == TYPE.RISK_RESULT_RED) ?
                    (win > 0) ? 'red' : 'black'
                    :
                    (win > 0) ? 'black' : 'red';
                balls.push({
                    s : color,
                    no_rotating : true,
                })
            }

            return { balls }
        } )
        .filter( some => some )
        .to( space.s( 'sportbet:risk_balls_desk:balls' ) )
}



// WEBPACK FOOTER //
// ./src/games/risk.es6